if (!customElements.get('order-dispatch-countdown')) {
  class OrderDispatchCountdown extends HTMLElement {
    connectedCallback() {
      this.endDate = new Date(this.dataset.endDate).getTime();
      if (!Number(this.endDate)) return;

      this.textEl = this.querySelector('.js-order-countdown');
      this.tick();
      this.interval = setInterval(this.tick.bind(this), 30000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      const diff = this.endDate - Date.now();

      if (diff <= 0) {
        clearInterval(this.interval);
        this.hidden = true;
        return;
      }

      const hours = Math.floor(diff / 3600000);
      const mins = Math.floor((diff % 3600000) / 60000);
      this.textEl.textContent = hours > 0 ? `${hours}h ${mins}m` : `${mins}m`;
    }
  }

  customElements.define('order-dispatch-countdown', OrderDispatchCountdown);
}
